import React from 'react';
import PropTypes from 'prop-types';
import { FormInput } from '@getro/rombo';
import { Text } from 'rebass/styled-components';

export const UrlField = ({ field, value, onChange, onBlur, error, disabled }) => {
  const isLinkedInField = field.label?.toLowerCase().includes('linkedin');
  const fieldName = field.id?.toString() || field.tempId;

  const helperContent = isLinkedInField ? (
    <Text as="span">
      To find it,{' '}
      <Text
        as="a"
        href="https://www.linkedin.com/in/"
        target="_blank"
        rel="noopener noreferrer"
        sx={{ textDecoration: 'underline' }}
      >
        click here
      </Text>{' '}
      and copy the URL from your browser.
    </Text>
  ) : (
    field.helperText
  );

  return (
    <FormInput
      label={field.label}
      labelExtra={field.required ? 'Required' : ''}
      type="url"
      disabled={disabled}
      helpText={helperContent}
      inputProps={{ style: { height: '48px' } }}
      field={{
        name: fieldName,
        value,
        onChange,
        onBlur,
      }}
      form={{
        errors: { [fieldName]: error },
        touched: { [fieldName]: !!error },
      }}
    />
  );
};

UrlField.propTypes = {
  field: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    tempId: PropTypes.string,
    label: PropTypes.string.isRequired,
    required: PropTypes.bool.isRequired,
    helperText: PropTypes.string,
  }).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  error: PropTypes.string,
  disabled: PropTypes.bool,
};

UrlField.defaultProps = {
  value: '',
  onChange: undefined,
  onBlur: undefined,
  error: undefined,
  disabled: false,
};
